import React from 'react';
import { Navigate } from 'react-router-dom';
import { authStorageService } from '@/modules/auth/services/authStorageService';

interface PublicRouteProps {
  children: React.ReactNode;
}

const PublicRoute: React.FC<PublicRouteProps> = ({ children }) => {
  const isAuthenticated = authStorageService.isAuthenticated();
  
  // If user is authenticated, redirect to dashboard
  // If not authenticated, allow access to public routes
  return isAuthenticated ? <Navigate to="/dashboard" replace /> : <>{children}</>;
};

export default PublicRoute;

